import React from 'react';
import NHModal from '../../NHModal/index';
import EditForm from './EditForm';
import {Form} from "antd";


class File extends React.Component {
    static defaultProps = {

    }
    constructor(props) {
        super(props);
        this.state = {
            content: undefined,
            editor: undefined,
        };
    }
    componentDidMount() {
        this.initBtn();
    }
    componentWillUnmount() {

    }

    initBtn = () => {
        let obj = this;
        let UE = this.props.UE;
        UE.registerUI('nhFile', function (editor, uiName) {
            //注册按钮执行时的command命令，使用命令默认就会带有回退操作
            editor.registerCommand(uiName, {
                execCommand: function () {
                    alert('execCommand:' + uiName)
                }
            });
            //创建一个button
            var btn = new UE.ui.Button({
                //按钮的名字
                name: uiName,
                //提示
                title: '附件上传',
                //添加额外样式，指定icon图标，这里默认使用一个重复的icon
                cssRules: 'background-position: -620px -40px;',
                //点击时执行的命令
                onclick: function () {
                    obj.setState({ editor: editor }, () => {
                        obj.refs.nhModal.show();
                    });
                    /* editor.execCommand( 'insertimage', {
                          src:'http://www.hnit.edu.cn/upfile/2018/2018424165944293.jpg',
                          width:'100',
                          height:'100'
                      } ); */
                }
            });
            //当点到编辑内容上时，按钮要做的状态反射
            editor.addListener('selectionchange', function () {
                btn.setDisabled(false);
            });
            //因为你是添加button,所以需要返回这个button
            return btn;
        });
    }

    handleSave = (stopLoading) => {
        let obj = this;
        this.refs.nhForm.validateFields((err, formData) => {
            if (err) {
                stopLoading();
                return;
            }
            let str = `<p><a  href="${formData.href ? formData.href : `anonymity/docrepo/download/file?attachmentId=${formData.attachmentId}`}" title="${formData.title ? formData.title : formData.fileName}">${formData.fileName}</a><br/></p>`;
            this.state.editor.execCommand('insertHTML', str);
            obj.refs.nhModal.close();
        });
    }

    render() {
        return (
            <div>
                <NHModal ref="nhModal"
                    title="附件上传"
                    onOk={this.handleSave}
                >
                    <EditForm ref="nhForm" content={this.state.content} />
                </NHModal>
            </div>)
    }
}
const form = Form.create()(File);
export default form;



// WEBPACK FOOTER //
// ./components/common/NHUeditor/file/index.js